export interface ActingOrg { id: number; name: string; }

const KEY = 'acting_org';

export function getActingOrg(): ActingOrg | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as ActingOrg;
  } catch {
    return null; // corrupt value → treat as no acting org
  }
}

export function setActingOrg(org: ActingOrg | null): void {
  if (org) localStorage.setItem(KEY, JSON.stringify(org));
  else localStorage.removeItem(KEY);
}

export function buildActingOrgHeader(): Record<string, string> {
  const org = getActingOrg();
  return org ? { 'X-Acting-Org-Id': String(org.id) } : {};
}
